import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "dd-chart-container"
};
const _hoisted_2 = {
  style: {
    "height": "auto"
  }
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "dd-title"
}, "概况", -1);

const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "dd-num-card"
}, [/*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "#888"
  }
}, "总人数"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-weight": "bold",
    "font-size": "20px"
  }
}, "1000")], -1);

const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "dd-num-card"
}, [/*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "#888"
  }
}, "拥有学历人数"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-weight": "bold",
    "font-size": "20px"
  }
}, "200")], -1);

const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "dd-num-card"
}, [/*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "#888"
  }
}, "党员人数"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-weight": "bold",
    "font-size": "20px"
  }
}, "500")], -1);

const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "dd-num-card"
}, [/*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "#888"
  }
}, "退休人数"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-weight": "bold",
    "font-size": "20px"
  }
}, "200")], -1);

const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<span class=\"dd-title\">员工类型分布</span><div id=\"chartYglx\"></div><span class=\"dd-title\">员工性别分布</span><div id=\"chartXbfb\"></div><span class=\"dd-title\">员工年龄构成</span><div id=\"chartNlgc\"></div><span class=\"dd-title\">学历分布</span><div id=\"chartXlfb\"></div><span class=\"dd-title\">临近退休人员排名</span><div id=\"chartTxryqs\"></div>", 10);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_grid_item = _resolveComponent("van-grid-item");

  const _component_van_grid = _resolveComponent("van-grid");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_van_grid, {
    direction: "horizontal",
    border: false,
    gutter: 10,
    "column-num": 2
  }, {
    default: _withCtx(() => [_createVNode(_component_van_grid_item, {
      icon: "friends-o"
    }, {
      text: _withCtx(() => [_hoisted_4]),
      _: 1
    }), _createVNode(_component_van_grid_item, {
      icon: "friends-o"
    }, {
      text: _withCtx(() => [_hoisted_5]),
      _: 1
    }), _createVNode(_component_van_grid_item, {
      icon: "friends-o"
    }, {
      text: _withCtx(() => [_hoisted_6]),
      _: 1
    }), _createVNode(_component_van_grid_item, {
      icon: "friends-o"
    }, {
      text: _withCtx(() => [_hoisted_7]),
      _: 1
    })]),
    _: 1
  })]), _hoisted_8]);
}